import http from '@/utils/http';

/**
 * 获取分页查询线索交接-tr
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/asset/transfer/lead/pageList',
        method: 'post',
        data
    });
};

/**
 * 线索-承接人-tr
 */
export function updateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/lead/update',
        method: 'post',
        data
    });
};

/**
 * 线索-批量保存/修改承接人-tr
 */
export function batchUpdateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/lead/batchUpsert',
        method: 'post',
        data
    });
};

/**
 * 线索-释放到公海池-tr
 */
export function releaseToPublicPool(data) {
    return http({
        url: '/api-lcrm/asset/transfer/lead/releaseToPublicPool',
        method: 'post',
        data
    });
};

/**
 * 导入-cyj
 */
export function importAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/lead/importLead',
        method: 'post',
        data
    });
};
